<div class="container-fluid">
	<app-alert-line [alertLineData]="alertLine"></app-alert-line>

	<h1>Détail du dossier '<strong>{{folderName}}</strong>'</h1>
	<br>

	<div class="row">
		<div class="col-12">
			<h2>Liste des fichiers à télécharger</h2>
		</div>
	</div>

	<ng-template [ngIf]="hasFileToDownload()">
		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevFileToDownload()" [disabled]="isFirstPageFileToDownload()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="resetFileToDownload()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextFileToDownload()" [disabled]="isLastPageFileToDownload()" styleClass="p-button-text"></p-button>
		</div>
		<p-table
			[value]="datasFilesToDownload"
			[columns]="columnsFilesToDownload"
			sortField="name"
			[paginator]="true"
			[rows]="rowsFilesToDownload"
			[showCurrentPageReport]="true"
			[(first)]="firstFilesToDownload"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} fichiers(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-database-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columns>
				<tr>
					<th *ngFor="let col of columns" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.field"></p-sortIcon>
					</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-columns-filter">
					</th>
					<th *ngIf="userRole=='A'">
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'path', 'contains')" placeholder="Recherche par chemin" class="p-columns-filter">
					</th>
					<th>&nbsp;</th>
					<th>&nbsp;</th>
					<th *ngIf="userRole=='A'">&nbsp;</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-file let-files="datasFilesToDownload">
				<tr>
					<td>
						<a href="javascript:void()" (click)="downloadDownloadableFile(file['name'])">{{file["name"]}}</a>
					</td>
					<td *ngIf="userRole=='A'">
						{{file["path"]}}
					</td>
                    <td>
						{{file["size_str"]}}
					</td>
                    <td>
						{{file["last_date"]}}
					</td>
					<td *ngIf="userRole=='A'">
						{{file["downloads"]}}
					</td>
				</tr>
			</ng-template>
		</p-table>
		<br>
	</ng-template>
	<br><br> 
	<hr>
	<br><br> 
	<ng-template [ngIf]="!hasFileToDownload()">
		<div class="row">
			<div class="col-12">
				<p *ngIf="userRole!='U'">Aucun fichier à télécharger.</p>
				<p *ngIf="userRole=='U'">Vous n'avez pas de fichier à télécharger.</p>
			</div>
		</div>
	</ng-template>

	<div class="row">
		<div class="col-12">
			<h2>Liste des fichiers déposés</h2>
		</div>
	</div>
	<ng-template [ngIf]="hasUploadedFile()">
		<div class="p-mb-3">
			<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevUploadedFile()" [disabled]="isFirstPageUploadedFile()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-refresh" (onClick)="resetUploadedFile()" styleClass="p-button-text"></p-button>
			<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextUploadedFile()" [disabled]="isLastPageUploadedFile()" styleClass="p-button-text"></p-button>
		</div>
		<p-table
			[value]="datasUploadedFiles"
			[columns]="columnsUploadedFiles"
			sortField="name"
			[paginator]="true"
			[rows]="rowsUploadedFiles"
			[showCurrentPageReport]="true"
			[(first)]="firstUploadedFiles"
			currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} fichiers(s)"
			[rowsPerPageOptions]="[10,25,50,100]"
			styleClass="p-database-striped"
			[autoLayout]=true
			#dt>
			<ng-template pTemplate="header" let-columns>
				<tr>
					<th *ngFor="let col of columns" [pSortableColumn]="col.sort">
						{{col.header}}
						<p-sortIcon [field]="col.field"></p-sortIcon>
					</th>
				</tr>
				<tr>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'name', 'contains')" placeholder="Recherche par nom" class="p-columns-filter">
					</th>
					<th>&nbsp;</th>
					<th>&nbsp;</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'username', 'contains')" placeholder="Recherche par utilisateur" class="p-columns-filter">
					</th>
					<th>
						<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'user_company_name', 'contains')" placeholder="Recherche par société" class="p-columns-filter">
					</th>
				</tr>
			</ng-template>
			<ng-template pTemplate="body" let-file let-files="datasUploadedFiles">
				<tr>
					<td>
						<a href="javascript:void()" (click)="downloadSelfFile(file['id'])">{{file["name"]}}</a>
					</td>
					<td>
						{{file["size_str"]}}
					</td>
                    <td>
						{{file["last_date"]}}
					</td>
					<td>
						<a href="mailto:{{file['username']}}">{{file["username"]}}</a><span *ngIf="file['user_fullname'] != ' '"> {{file["user_fullname"]}}</span>
					</td>
					<td>
						<span *ngIf="file['user_company_name'] == '-'">-</span>
						<a *ngIf="file['user_company_name'] != '-'" routerLink="/company-detail/{{file['user_company']}}">{{file["user_company_name"]}}</a>
					</td>
				</tr>
			</ng-template>
		</p-table>
		<br>
	</ng-template>

	<ng-template [ngIf]="!hasUploadedFile()">
		<div class="row">
			<div class="col-12">
				<p *ngIf="userRole!='U'">Aucun fichier déposé dans ce dossier.</p>
				<p *ngIf="userRole=='U'">Vous n'avez pas déposé de fichier dans ce dossier.</p>
			</div>
		</div>
	</ng-template>

	<div class="row" *ngIf="userRole!='A'">
		<div class="col-12">
			<button type="button" class="btn btn-primary material-item" (click)="doUploadFile()"><i class="material-icons md-24 icons">add_box</i> Déposer un fichier...</button>
		</div>
	</div>
	<br><br> 
	<div *ngIf="userRole=='A' || userRole=='I'">
		<hr>
		<br><br> 
		<div class="row">
			<div class="d-flex col-12">
				<h2>Statistique concernant les fichiers non téléchargés par les utilisateurs</h2>
				&nbsp; &nbsp;
				<button matTooltip="Télécharger les statistiques concernant les fichiers non téléchargés" class="btn btn-primary material-item" type="button" mat-raised-button (click)="downloadNotDownloadedFileStats()"><i class="material-icons md-24 icons">file_download</i></button>
			</div>
		</div>
		<ng-template [ngIf]="hasNotDownloadedFilesStats()">
			<div class="p-mb-3">
				<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevNotDownloadedFilesStats()" [disabled]="isFirstPageNotDownloadedFilesStats()" styleClass="p-button-text"></p-button>
				<p-button type="button" icon="pi pi-refresh" (onClick)="resetNotDownloadedFilesStats()" styleClass="p-button-text"></p-button>
				<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextNotDownloadedFilesStats()" [disabled]="isLastPageNotDownloadedFilesStats()" styleClass="p-button-text"></p-button>
			</div>
			<p-table
				[value]="datasStatsNotDownloadedFiles"
				[columns]="columnsStatsNotDownloadedFiles"
				sortField="username"
				[paginator]="true"
				[rows]="rowsStatsNotDownloadedFiles"
				[showCurrentPageReport]="true"
				[(first)]="firstStatsNotDownloadedFiles"
				currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} utilisateur(s)"
				[rowsPerPageOptions]="[10,25,50,100]"
				styleClass="p-database-striped"
				[autoLayout]=true
				#dt>
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th *ngFor="let col of columns" [pSortableColumn]="col.sort">
							{{col.header}}
							<p-sortIcon [field]="col.field"></p-sortIcon>
						</th>
					</tr>
					<tr>
						<th>
							<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'username', 'contains')" placeholder="Recherche par identifiant" class="p-columns-filter">
						</th>
						<th>
							<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'notDownloadedFile', 'contains')" placeholder="Recherche par fichier" class="p-columns-filter">
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-user let-users="datasStatsNotDownloadedFiles">
					<tr>
						<td>
							<a href="mailto:{{user['username']}}">{{user["username"]}}</a><span *ngIf="user['user_fullname'] != ' '"> {{user["fullname"]}}</span>
						</td>
						<td >
							{{user['notDownloadedFile']}}
						</td>
					</tr>
				</ng-template>
			</p-table>
			<br>
		</ng-template>

		<ng-template [ngIf]="!hasNotDownloadedFilesStats()">
			<div class="row">
				<div class="col-12">
					<p>Aucune statistique n'a été trouvé concernant les fichiers non téléchargés par les utilisateurs.</p>
				</div>
			</div>
		</ng-template>
		<br><br> 
		<hr>
		<br><br> 
		<div class="row">
			<div class="d-flex col-12">
				<h2>Statistique concernant les réponses des utilisateurs</h2>
				&nbsp; &nbsp;
				<button matTooltip="Télécharger les statistiques concernant les réponses des utilisateurs" class="btn btn-primary material-item" type="button" mat-raised-button (click)="downloadAnwsersStats()"><i class="material-icons md-24 icons">file_download</i></button>
			</div>
		</div>
		<ng-template [ngIf]="hasAnswersStats()">
			<div class="p-mb-3">
				<p-button type="button" icon="pi pi-chevron-left" (onClick)="prevAnswersStats()" [disabled]="isFirstPageAnswersStats()" styleClass="p-button-text"></p-button>
				<p-button type="button" icon="pi pi-refresh" (onClick)="resetAnswersStats()" styleClass="p-button-text"></p-button>
				<p-button type="button" icon="pi pi-chevron-right" (onClick)="nextAnswersStats()" [disabled]="isLastPageAnswersStats()" styleClass="p-button-text"></p-button>
			</div>
			<p-table
				[value]="datasStatsAnswers"
				[columns]="columnsStatsAnswers"
				sortField="username"
				[paginator]="true"
				[rows]="rowsStatsAnswers"
				[showCurrentPageReport]="true"
				[(first)]="firstStatsAnswers"
				currentPageReportTemplate="Affichage de {first} à {last} sur {totalRecords} utilisateur(s)"
				[rowsPerPageOptions]="[10,25,50,100]"
				styleClass="p-database-striped"
				[autoLayout]=true
				#dt>
				<ng-template pTemplate="header" let-columns>
					<tr>
						<th *ngFor="let col of columns" [pSortableColumn]="col.sort">
							{{col.header}}
							<p-sortIcon [field]="col.field"></p-sortIcon>
						</th>
					</tr>
					<tr>
						<th>
							<input pInputText type="text" (input)="dt.filter(filterColumns($event), 'username', 'contains')" placeholder="Recherche par identifiant" class="p-columns-filter">
						</th>
						<th>
							<p-dropdown [options]="answerChoice" appendTo="body" (onChange)="dt.filter($event.value, 'answer', 'equals')" styleClass="p-column-filter" placeholder="Choix du type de réponse" [showClear]="true">
								<ng-template let-option pTemplate="item">
									<span [class]="'customer-badge status-'+option.value">{{option.label}}</span>
								</ng-template>
							</p-dropdown>
						</th>
					</tr>
				</ng-template>
				<ng-template pTemplate="body" let-user let-users="datasStatsAnswers">
					<tr>
						<td>
							<a href="mailto:{{user['username']}}">{{user["username"]}}</a><span *ngIf="user['user_fullname'] != ' '"> {{user["fullname"]}}</span>
						</td>
						<td>
							<span class="ls-state-running" *ngIf="user['answer'] == 'F'">Suivi</span>
							<span class="ls-state-inactive" *ngIf="user['answer'] == 'NF'">Non suivi</span>
							<span class="ls-state-waiting" *ngIf="user['answer'] == 'NA'">Pas de réponse</span>
						</td>
					</tr>
				</ng-template>
			</p-table>
			<br>
		</ng-template>

		<ng-template [ngIf]="!hasAnswersStats()">
			<div class="row">
				<div class="col-12">
					<p>Aucune statistique n'a été trouvé concernant les réponses des utilisateurs.</p>
				</div>
			</div>
		</ng-template>
	</div>
</div>
